import AppConfig from 'config/app-config';

export const getConfig = () => AppConfig;
